module.exports = __webpack_public_path__ + "71492c90c15aabb117180307034775e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/MCA - Pipilotti Rist - Gnade Donau Gnade2.jpg
// module id = 881
// module chunks = 0